



























































































import { Component, mixins } from '@niknevis/vue-modules'
import Heading from '@/modules/common/layout/components/shared/Heading.vue'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import { Filter, FilterTypes } from '@/modules/common/filter/filter'
import collect from 'collect.js'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import { Paginated } from '@/modules/shared/models/data'
import QTable from 'quasar/src/components/table/QTable.js';
import Pagination from '@/modules/shared/components/shared/pagination/Pagination.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import { WriterRoutes } from '@/modules/shared/routes/writer'

@Component({
  components: { FilterRow, Heading, Pagination, TesTable }
})
export default class index extends mixins(QsPaginatableMixin, QsSearchableMixin) {
  constructor(
    private readonly routes: WriterRoutes
  ) {
    super()
  }

  @ProvideReactive()
  @Prop() tickets!: Paginated<Ticket[]>

  private rowComponent = TicketIndexRow

  private filters = [
    new Filter({
      type: FilterTypes.ComboBox,
      title: 'وضعیت',
      key: 'statuses',
      holder: 'همه وضعیت ها',
      typeMode: false,
      items: collect(this.tickets.statuses)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    })
  ]

  protected get model() {
    return this.tickets
  }

  @ProvideReactive()
  private get route() {
    return this.routes
  }

  updatePage(page: number) {
    this.updateTable({
      pagination: {
        ...this.pagination,
        page
      }
    })
  }

  private ticketColumn: QTable['columns'] =
    this.$q.screen.gt.sm ? [
      {
        name: 'id',
        label: 'شماره تیکت',
        field: 'id',
        align: 'left'
      },
      {
        name: 'title',
        label: 'عنوان تیکت',
        field: 'title',
        align: 'left'
      },
      {
        name: 'last_answer_date',
        label: 'تاریخ آخرین پاسخ',
        field: 'last_answer_date',
        align: 'left'
      },
      {
        name: 'status',
        label: 'وضعیت',
        field: 'status',
        align: 'left'
      }
    ] : [
      {
        name: 'title',
        label: 'عنوان تیکت',
        field: 'title',
        align: 'left'
      },
      {
        name: 'id',
        label: 'شماره تیکت',
        field: 'id',
        align: 'left'
      },
      {
        name: 'last_answer_date',
        label: 'تاریخ آخرین پاسخ',
        field: 'last_answer_date',
        align: 'left'
      }
    ]

}
